import { DialogRef } from '@angular/cdk/dialog';
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { BusApiService } from 'src/app/services/api/bus-api.service';
import { MessageService } from 'src/app/services/message.service';

@Component({
  selector: 'app-freeze-modal',
  templateUrl: './freeze-modal.component.html',
  styleUrls: ['./freeze-modal.component.scss'],
})
export class FreezeModalComponent implements OnInit {
  loading = false;
  index = 1;
  now = new Date();
  after = new Date();

  constructor(
    private dialogRef: DialogRef<FreezeModalComponent>,
    private api: BusApiService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private message: MessageService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.after.setMonth(this.now.getMonth() + 3);
  }

  name = '';
  async refund() {
    if (this.index === 1) {
      this.name = '冻结补偿三个月';
    } else if (this.index === 2) {
      this.name = '冻结补偿六个月';
    }

    try {
      this.loading = true;
      const r = await this.api.freezeTime(this.data.id, this.name);
      if (r.status === 0) {
        this.message.open('冻结成功');
        this.dialogRef.close();
        this.router
          .navigateByUrl('/', { skipLocationChange: true })
          .then(() => {
            this.router.navigate(['/user/profile/seats']);
          });
      } else {
        this.message.warn('冻结失败');
      }
    } catch (error) {
    } finally {
      this.loading = false;
    }
  }

  changeTime(i: any) {
    this.index = i;
    this.after = new Date(this.now);
    if (this.index === 1) {
      this.after.setMonth(this.now.getMonth() + 3);
    } else if (this.index === 2) {
      this.after.setMonth(this.now.getMonth() + 6);
    }
  }
}
